<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="bg-white p-2 p-lg-3">
        <b-row class="row-gap-md" v-if="form.fields.length > 0">
          <template v-for="(field, index) of form.fields">
            <b-col
              :key="'field-' + field.id + index"
              :cols="layout"
              v-if="isProduct || (!isProduct && field.is_using_in_formula == 1)"
            >
              <template v-if="field.field_type_id == 2">
                <label for="">{{ field.name }} </label>

                <b-form-checkbox-group
                  :id="'checkbox-' + field.id"
                  :name="'checkbox-' + field.id"
                  :options="field.field_choices"
                  v-model="field.value"
                  value-field="id"
                  text-field="name"
                  stacked
                ></b-form-checkbox-group>
              </template>
              <template v-else-if="field.field_type_id == 3">
                <label for="">{{ field.name }} </label>
                <multiselect
                  :close-on-select="false"
                  :clear-on-select="false"
                  :options="field.field_choices"
                  v-model="field.value"
                  :placeholder="field.name"
                  track-by="id"
                  label="name"
                  multiple
                >
                  <template v-slot:option-first>
                    <b-form-select-option :value="null"
                      >-- Select {{ field.name }} --</b-form-select-option
                    >
                  </template>
                </multiselect>
              </template>
              <template v-else-if="field.field_type_id == 4">
                <InputSelect
                  :title="field.name"
                  :name="field.name"
                  v-model="field.value"
                  v-bind:options="field.field_choices"
                  valueField="id"
                  textField="name"
                  class="mb-0"
                >
                  <!-- {{ undefined }} -->
                  <template v-slot:option-first>
                    <b-form-select-option value="" disabled>
                      -- Select {{ field.name }} --
                    </b-form-select-option>
                  </template>
                </InputSelect>
              </template>
              <template v-else-if="field.field_type_id === 6">
                <InputSelect
                  :title="field.name"
                  :name="field.name"
                  v-model="field.value"
                  v-bind:options="field.branch_list || []"
                  valueField="id"
                  textField="name"
                  class="mt-3"
                >
                  <template v-slot:option-first>
                    <b-form-select-option value=""
                      >-- Select {{ field.name }} --</b-form-select-option
                    >
                  </template>
                </InputSelect>
              </template>
              <template v-else-if="field.field_type_id === 5">
                <b-row>
                  <template>
                    <div>
                      <label class="label">{{ field.name }}</label>
                    </div>
                    <div class="datetime-container">
                      <datetime
                        :textFloat="field.name"
                        type="datetime"
                        :name="'date-' + index"
                        :class="['date-picker-input', 'date-filter']"
                        :ref="'date-' + index"
                        v-model="field.value"
                        @input="(val) => (field.value = val)"
                        class="datetime-h custom-date-picker"
                        format="dd/MM/yyyy hh:mm"
                      />
                      <div class="calendar-icon">
                        <font-awesome-icon icon="calendar-alt" />
                      </div>
                    </div>
                  </template>
                </b-row>
              </template>
              <template v-else-if="field.field_type_id === 7">
                <template>
                  <div>
                    <label class="label">{{ field.name }}</label>
                  </div>
                  <div class="datetime-container">
                    <datetime
                      :textFloat="field.name"
                      type="date"
                      :name="'date-' + index"
                      :class="['date-picker-input', 'date-filter']"
                      :ref="'date-' + index"
                      v-model="field.value"
                      @input="(val) => (field.value = val)"
                      class="datetime-h custom-date-picker"
                      format="dd/MM/yyyy"
                    />
                    <div class="calendar-icon">
                      <font-awesome-icon icon="calendar-alt" />
                    </div>
                  </div>
                </template>
              </template>
              <template v-else-if="field.field_type_id === 8">
                <UploadFile
                  v-model="field.value"
                  :value="field.value"
                  :textFloat="field.name"
                  :placeholder="field.name"
                  format="image"
                  name="thumbnail"
                  className="mb-0"
                  accept="image/jpeg, image/png"
                  text="*Please upload only file .png, .jpg size 1:1  and less than 10 MB"
                  v-on:onFileChange="($event) => onImageChange($event, index)"
                  :fileName="field.value"
                />
                <!-- <div @click="showImage(field.value)" v-if="field.value">
                  <PreviewBox
                    v-on:delete="onDeleteImage(index)"
                    :disabled="false"
                    :showPreviewType="0"
                    :showPreview="field.value"
                    :isLoadingImage="false"
                    :ratioType="1"
                  />
                </div> -->
              </template>
              <template v-else-if="field.field_type_id === 12">
                <InputTextArea
                  :textFloat="field.name"
                  v-model="field.value"
                  type="text"
                  :placeholder="field.name"
                  className="mb-0"
                  rows="3"
                />
              </template>
              <template v-else>
                <InputText
                  :textFloat="field.name"
                  :placeholder="field.name"
                  v-model="field.value"
                  value=""
                  type="text"
                  class="mb-0"
              /></template>
              <!-- <div class="break-normal" :key="'break-normal' + field.id"></div> -->
            </b-col>
          </template>
        </b-row>
        <template v-else>
          <div class="text-center">
            Custom Field Is Empty
            <br />
            <b-button
              variant="custom-outline-primary"
              @click="$router.push('/setting/product-field')"
              class="mt-3"
            >
              <font-awesome-icon icon="plus"></font-awesome-icon>
              Create Custom Field</b-button
            >
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import Multiselect from "vue-multiselect";
// import PreviewBox from "@/components/PreviewBox.vue";
export default {
  components: { OtherLoading, Multiselect },
  props: {
    form: {
      required: false,
    },
    layout: {
      required: false,
      default: 6,
    },

    isProduct: {
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isLoading: true,
      selected: [],
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },

  validations: {},
  watch: {},
  async created() {
    this.getField();
  },

  methods: {
    async getField() {
      this.isLoading = false;
    },
    onImageChange(img, index) {
      this.$bus.$emit("showLoading");
      var reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = async () => {
        const images = await this.saveImagetoDb(reader.result);
        this.isLoadingImage = false;
        this.isDisable = false;
        this.form.fields[index].value = images;

        this.$forceUpdate();
        this.$bus.$emit("hideLoading");
      };
    },
    saveImagetoDb: async function (img) {
      var form = {
        Base64String: img,
      };
      await this.$store.dispatch("ActionUploadImage", form);
      var data = await this.$store.state.moduleConnectAPI.stateUploadImage;
      if (data.result == 1) {
        return data.detail;
      }
    },
    onDeleteImage(index) {
      this.form.fields[index].value = null;
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-icon {
  position: absolute;
  top: 20%;
  right: 3%;
}
.datetime-container {
  position: relative;
  //   width: 230px;
}
</style>
